import React, { useState } from 'react';
import { Button } from 'antd';

interface TextInputCardProps {
  savedValue?: string;
  onSubmit: (value: string) => void;
  isDisabled?: boolean;
  placeholder?: string;
}

export const TextInputCard: React.FC<TextInputCardProps> = ({
  savedValue = '',
  onSubmit,
  isDisabled = false,
  placeholder = 'Enter your answer...',
}) => {
  const [textValue, setTextValue] = useState(savedValue);

  const handleSubmit = () => {
    onSubmit(textValue.trim());
  };

  return (
    <div className="flex w-auto border border-neutral-400 p-4 rounded-lg mb-4">
      <div className="w-full space-y-3">
        <textarea
          className="w-full bg-white border border-neutral-300 rounded-lg px-4 py-3 text-text-primary focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder={placeholder}
          value={textValue}
          onChange={(e) => setTextValue(e.target.value)}
          disabled={isDisabled}
        />
        <Button
          type="primary"
          size="large"
          block
          onClick={handleSubmit}
          disabled={isDisabled}
          className="font-semibold"
        >
          Submit
        </Button>
      </div>
    </div>
  );
};
